import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconEditFilled = createSVG({
    children: (jsx("path", { d: "M20.946 8.114 7.34 21.696a1.2 1.2 0 0 1-.328.235.9.9 0 0 1-.375.07H3.03a1 1 0 0 1-.725-.304.98.98 0 0 1-.304-.725v-3.607q0-.21.07-.375.091-.183.235-.328L15.888 3.056q1.053-1.053 2.528-1.054 1.476 0 2.53 1.054T22 5.585t-1.054 2.529m-5.949-1.99 2.881 2.88 1.991-1.991q.585-.584.586-1.43 0-.843-.586-1.451a2.04 2.04 0 0 0-1.452-.586 1.94 1.94 0 0 0-1.429.586z" })),
});

export { IconEditFilled };
